// extracted by mini-css-extract-plugin
export var quillEditor = "_n9-1";
export var variable = "_n9-0";